import { resolveConnectorIconUrl } from "../../utils/connectorIcons";
import type {
  WorkspaceLinkedDataSource,
  WorkspaceLinkedDataSourceApi,
  WorkspaceLinkedDataSourceListResponse,
  WorkspaceLinkedDataSourceListResponseApi,
} from "./workspaceDataSources.types";

export const mapWorkspaceLinkedDataSource = (
  api: WorkspaceLinkedDataSourceApi,
): WorkspaceLinkedDataSource => ({
  id: api.id,
  connectionId: api.connection_id,
  name: api.connection_name,
  catalogKey: api.catalog_key,
  iconUrl: resolveConnectorIconUrl({
    catalogKey: api.catalog_key,
    serverIconUrl: api.icon_url,
  }),
  domain: api.catalog_display_name ?? api.domain ?? null,
  status: api.status,
});

export const mapWorkspaceLinkedDataSourceListResponse = (
  api: WorkspaceLinkedDataSourceListResponseApi,
): WorkspaceLinkedDataSourceListResponse => ({
  items: api.items.map(mapWorkspaceLinkedDataSource),
  total: api.total,
});
